import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { NavItem } from './types';

interface DesktopNavigationProps {
  mainNavItems: NavItem[];
  isDashboardPage: boolean;
}

export const DesktopNavigation: React.FC<DesktopNavigationProps> = ({ 
  mainNavItems, 
  isDashboardPage 
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className={`hidden lg:flex items-center flex-1 justify-start transition-all duration-500 ease-in-out ${isDashboardPage ? 'lg:ml-0' : 'ml-8'}`}>
      <div className="flex items-center gap-6">
        {mainNavItems.map(item => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={
                `text-sm font-medium transition-all duration-500 ease-in-out px-4 py-2 rounded-lg ` +
                (isDashboardPage
                  ? isActive
                    ? 'lg:bg-primary-50 lg:text-primary-700 lg:border lg:border-primary-200 lg:shadow-sm text-primary-600 font-semibold'
                    : 'lg:text-gray-700 lg:hover:bg-gray-100 lg:border lg:border-transparent lg:hover:border-gray-200 text-gray-600 hover:text-gray-900'
                  : isActive
                    ? 'text-primary-600 font-semibold'
                    : 'text-gray-600 hover:text-gray-900')
              }
            >
              {item.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}; 